module.exports = __webpack_public_path__ + "static/media/masjid_kichula6.87a3c48d.webp";